import type { WaitlistFeatureOptions } from '.'
import { WaitlistViewModel } from './WaitlistView/WaitlistViewModel'

export function InternalWaitlistFeature(options: WaitlistFeatureOptions) {
  const waitlistVm = new WaitlistViewModel(options.getCurrentMember)

  return {
    waitlistVm,
  }
}
